
import { supabase } from '@/integrations/supabase/client';

/**
 * Enriches procurement data with source name based on source_type and source_id
 */
export const enrichProcurementWithSourceName = async (procurement: any) => {
  if (!procurement.source_type || !procurement.source_id) {
    return { ...procurement, source_name: procurement.source_type || 'Unknown' };
  }

  let sourceName = 'Unknown';
  
  try {
    switch (procurement.source_type) {
      case 'supplier':
        const { data: supplier } = await supabase
          .from('suppliers')
          .select('name')
          .eq('id', procurement.source_id)
          .single();
        sourceName = supplier?.name || 'Unknown Supplier';
        break;
        
      case 'agent':
        const { data: agent } = await supabase
          .from('agents')
          .select('name')
          .eq('id', procurement.source_id)
          .single();
        sourceName = agent?.name || 'Unknown Agent';
        break;
        
      case 'farm':
        const { data: farm } = await supabase
          .from('farms')
          .select('farmer_name')
          .eq('id', procurement.source_id)
          .single();
        sourceName = farm?.farmer_name || 'Unknown Farm';
        break;
        
      default:
        sourceName = procurement.source_type;
    }
  } catch (error) {
    console.error('Error fetching source name:', error);
    sourceName = procurement.source_type || 'Unknown';
  }

  return { ...procurement, source_name: sourceName };
};
